import React from 'react';
import styled from '@emotion/styled';
import { colors } from 'src/theme';
import CheckIcon from 'src/assets/images/check.svg';

const AmountCardStyle = styled.div<{ isSelected: boolean; hasAnySelection: boolean }>(props => ({
  display: 'flex',
  alignItems: 'center',
  gap: 6,
  flex: '1 1 0%',
  minWidth: 0,
  padding: '12px 16px',
  borderRadius: 8,
  border: `2px solid ${props.isSelected ? colors.primary : colors.border2}`,
  backgroundColor: props.isSelected ? '#F5E6FF' : colors.white,
  cursor: 'pointer',
  transition: 'all 0.2s ease',
  fontSize: 12,
  fontWeight: 500,
  whiteSpace: 'nowrap',
  justifyContent: 'center',
  opacity: props.hasAnySelection && !props.isSelected ? 0.4 : 1,

  '@media (max-width: 575px)': {
    minWidth: 0,
  },

  '&:hover': {
    borderColor: colors.primary,
  },
}));


export interface AmountCardProps {
  label: string;
  isSelected: boolean;
  onClick: () => void;
  hasAnySelection?: boolean;
}

export const AmountCard: React.FC<AmountCardProps> = ({ label, isSelected, onClick, hasAnySelection = false }) => (
  <AmountCardStyle isSelected={isSelected} hasAnySelection={hasAnySelection} onClick={onClick}>
    {isSelected && <img src={CheckIcon} alt="Check" width={16} height={16} />}
    {label}
  </AmountCardStyle>
);
